import { render, staticRenderFns } from "./SwtichStudentTemplate.vue?vue&type=template&id=55400d5e&scoped=true&"
import script from "./SwtichStudentTemplate.vue?vue&type=script&lang=js&"
export * from "./SwtichStudentTemplate.vue?vue&type=script&lang=js&"
import style0 from "./SwtichStudentTemplate.vue?vue&type=style&index=0&id=55400d5e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55400d5e",
  null
  
)

export default component.exports